import { useTranslation } from 'react-i18next';
import { Flex, Text } from '@chakra-ui/react';
import { Logo } from 'images/Logo';

import { logoLanguage } from '../../util/lang';
import { LogoUnderline } from './LogoUnderline';

export const LogoWithTagLine = () => {
  const { t } = useTranslation('naban');

  return (
    <Flex flexDirection='column' alignItems='center' gap={4}>
      <Logo lang={logoLanguage} />
      <LogoUnderline />
      <Text fontSize='0.875rem' textTransform='uppercase'>
        {t('logo.tagline')}
      </Text>
    </Flex>
  );
};
